export default {"src":"/_next/static/media/Canpar.ffe6135e.svg","height":253,"width":1075};